import React from "react";
import banner from "../assets/img/Logo-digitalizadores.png"

const BannerSection = () => {
  return (
    <section className="container mx-auto py-10">
      <div className="flex justify-center items-center px-4">
        <img className="object-contain max-w-full h-auto max-h-32 md:max-h-40" src={banner} alt="banner" />
      </div>
    </section>
  );
};

export default BannerSection;
